module.exports = __webpack_public_path__ + "static/media/RESTORE.42b6996c.svg";